import { render, staticRenderFns } from "./AdminContactFormulier.vue?vue&type=template&id=564e62b8&scoped=true&"
import script from "./AdminContactFormulier.vue?vue&type=script&lang=js&"
export * from "./AdminContactFormulier.vue?vue&type=script&lang=js&"
import style0 from "./AdminContactFormulier.vue?vue&type=style&index=0&id=564e62b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e62b8",
  null
  
)

export default component.exports